<!--
输入字段

使用说明：

<CardSearch
 :placeholder="'提示文本'"
 />

-->

<template>
    <div class="search">
        <form @submit.prevent="onSubmit">
            <img class="s-img" src="http://res.uuudian.com/hk_data/7170b472-778a-4382-bc62-dd44061b53b8" alt="">
            <input type="text" :placeholder="placeholder" v-model="val" @input="onInput">
        </form>
        <!-- <Button type="primary" @click="search" >搜索</Button> -->
    </div>
</template>

<script>
export default {
  props: ['placeholder'],
  data () {
      return {
          val: this.value
      }
  },
  watch: {
      value (newVal, objVal) {
          this.val = newVal
      }
  },
  methods: {
      onInput () {
          this.$emit('change', this.val)
      },
      search () {
          this.$emit('search');
      },
      onSubmit(){
          console.log('onSubmit...');
          this.$emit('search');
      }
  }
}
</script>

<style lang="less" scoped>

.search {
    form {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    background: #fff;
    margin-bottom: 2vw;
    
    position: relative;
    .s-img {
        position: absolute;
        left: 8vw;
        top: 4.5vw;
        width: 5vw;
    }
    input {
        width: 80vw;
        color: #999;
        border: 1px solid #eaeaea;
        border-radius: 5px;
        font-size: 3.2vw;
        height: 8.0666vw;
        padding-left: 10vw;
        margin: 2.333vw 0;
        margin-right: 5px
    }
}


</style>



// WEBPACK FOOTER //
// src/components/orders/CardSearch.vue